import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateHouseRulesComponent } from './update-house-rules.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    UpdateHouseRulesComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
    UpdateHouseRulesComponent
  ]
})
export class UpdateHouseRulesModule { }
